import { Alert, Divider } from '@mui/material'
import type { $Table } from 'element-domain/src/__generated/enhanced-model'
import { LeafTypes, SeatingTypes } from 'element-domain/src/__generated/model'

import { AttributeToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface AccessoriesPropertyPageProps {
  table: $Table
}

export default function AccessoriesPropertyPage({ table }: AccessoriesPropertyPageProps) {
  return (
    <PropertyContainer.Section title="Accessories">
      <Divider sx={{ my: 2.5 }} />
      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Leaf">
          <AttributeToggleSelector entityId={table.$top.id} instanceName="leafType" columnCount={2} />
          {table.$top.$violations?.some(v => v.type === 'customLeafSizeNeedsPersonalizedQuote') && (
            <Alert severity="warning" sx={{ mt: 1 }}>
              Custom leaf size needs a personalized quote.
            </Alert>
          )}
        </PropertyContainer.Item>

        {table.$top.leafType !== LeafTypes.NoLeaf && (
          <PropertyContainer.Item title="Leaf Amount">
            <AttributeToggleSelector entityId={table.$top.id} instanceName="leafAmount" columnCount={2} />
          </PropertyContainer.Item>
        )}

        <PropertyContainer.Item title="Seating">
          <AttributeToggleSelector entityId={table.id} instanceName="seatingType" columnCount={2} />
        </PropertyContainer.Item>

        {table.seatingType === SeatingTypes.Benches && (
          <PropertyContainer.Item title="Bench Amount">
            <AttributeToggleSelector entityId={table.id} instanceName="seatingAmount" columnCount={2} />
          </PropertyContainer.Item>
        )}
      </PropertyContainer.Group>
    </PropertyContainer.Section>
  )
}
